import i18n from 'shared/lib/i18n';

import {
  ADD_MESSAGE_SELLER_FAILURE,
  ADD_MESSAGE_SELLER_REQUEST,
  ADD_MESSAGE_SELLER_SUCCESS,
  BAN_MEMBER_FAILURE,
  BAN_MEMBER_REQUEST,
  BAN_MEMBER_SUCCESS,
  CLEAR_MEMBERS_LIST_REQUEST,
  CLEAR_POSTS_LIST_REQUEST,
  COMMUNITY_DROP_MESSAGES,
  COMMUNITY_OPT_IN_OUT_FAILURE,
  COMMUNITY_OPT_IN_OUT_REQUEST,
  COMMUNITY_OPT_IN_OUT_SUCCESS,
  COMMUNITY_SET_DOCUMENT_ATTACHMENT,
  COMMUNITY_THREAD_EXISTS_FAILURE,
  COMMUNITY_THREAD_EXISTS_REQUEST,
  COMMUNITY_THREAD_EXISTS_SUCCESS,
  CREATE_POST_COMMENT_FAILURE,
  CREATE_POST_COMMENT_REQUEST,
  CREATE_POST_COMMENT_SUCCESS,
  GET_COMMUNITY_CHATS_FAILURE,
  GET_COMMUNITY_CHATS_REQUESTED,
  GET_COMMUNITY_CHATS_SUCCESS,
  GET_COMMUNITY_CHAT_BY_ID_FAILURE,
  GET_COMMUNITY_CHAT_BY_ID_REQUEST,
  GET_COMMUNITY_CHAT_BY_ID_SUCCESS,
  GET_COMMUNITY_CHAT_INFO_BY_ID_FAILURE,
  GET_COMMUNITY_CHAT_INFO_BY_ID_REQUEST,
  GET_COMMUNITY_CHAT_INFO_BY_ID_SUCCESS,
  GET_COMMUNITY_LIST_FAILURE,
  GET_COMMUNITY_LIST_REQUEST,
  GET_COMMUNITY_LIST_SUCCESS,
  GET_COMMUNITY_MEMBERS_LIST_FAILURE,
  GET_COMMUNITY_MEMBERS_LIST_FOR_FILTER_FAILURE,
  GET_COMMUNITY_MEMBERS_LIST_FOR_FILTER_REQUEST,
  GET_COMMUNITY_MEMBERS_LIST_FOR_FILTER_SUCCESS,
  GET_COMMUNITY_MEMBERS_LIST_REQUEST,
  GET_COMMUNITY_MEMBERS_LIST_SUCCESS,
  GET_ITEMS_FOR_EXPORT_SUCCESS,
  GET_POSTS_COMMENTS_LIST_FAILURE,
  GET_POSTS_COMMENTS_LIST_REQUEST,
  GET_POSTS_COMMENTS_LIST_SUCCESS,
  GET_POSTS_LIST_FAILURE,
  GET_POSTS_LIST_REQUEST,
  GET_POSTS_LIST_SUCCESS,
  GET_POST_BY_ID_FAILURE,
  GET_POST_BY_ID_REQUEST,
  GET_POST_BY_ID_SUCCESS,
  PRELOAD_DOCUMENT_FAILURE,
  PRELOAD_DOCUMENT_REQUEST,
  PRELOAD_DOCUMENT_SUCCESS,
  PUT_NEW_MESSAGE_FAILURE,
  PUT_NEW_MESSAGE_REQUESTED,
  PUT_NEW_MESSAGE_SUCCESS,
  REMOVE_COMMENT_FAILURE,
  REMOVE_COMMENT_REQUEST,
  REMOVE_COMMENT_SUCCESS,
  REMOVE_POST_FAILURE,
  REMOVE_POST_REQUEST,
  REMOVE_POST_SUCCESS,
  SET_MODAL_TYPE,
  SUBMIT_POST_FAILURE,
  SUBMIT_POST_REQUEST,
  SUBMIT_POST_SUCCESS,
  TOGGLE_POST_LIKE_FAILURE,
  TOGGLE_POST_LIKE_REQUEST,
  TOGGLE_POST_LIKE_SUCCESS,
  UPDATE_COMMUNITY_FAILURE,
  UPDATE_COMMUNITY_ITEM_STATUS_FAILURE,
  UPDATE_COMMUNITY_ITEM_STATUS_REQUEST,
  UPDATE_COMMUNITY_ITEM_STATUS_SUCCESS,
  UPDATE_COMMUNITY_REQUEST,
  UPDATE_COMMUNITY_SUCCESS,
} from '../../actionConstants';
import { uploadImage } from '../Visitor/actionCreators';

import { isAdmin } from '../../utils';
import { getUserInfo } from '../Navigation/utils';

import apiClient from '../../apiClient';
import { CONFIRM } from '../Modal/modalTypes';

export const getCommunityList = (
  dispatch,
  queryParams,
  isExport,
  isWithoutPagination,
) => {
  const request = isAdmin()
    ? apiClient.community.getAdminList
    : apiClient.community.getList;

  return dispatch({
    type: GET_COMMUNITY_LIST_REQUEST,
    withoutLoading: isExport,
    payload: request(queryParams).then(
      (res) => {
        dispatch({
          type: isExport
            ? GET_ITEMS_FOR_EXPORT_SUCCESS
            : GET_COMMUNITY_LIST_SUCCESS,
          res,
          isWithoutPagination,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: GET_COMMUNITY_LIST_FAILURE,
          err,
        }),
    ),
  });
};

export const updateCommunity = (dispatch, id, data) =>
  dispatch({
    type: UPDATE_COMMUNITY_REQUEST,
    payload: apiClient.community.update(id, data).then(
      (res) => {
        dispatch({
          type: UPDATE_COMMUNITY_SUCCESS,
          id,
          res,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: UPDATE_COMMUNITY_FAILURE,
          err,
        }),
    ),
  });

export const updatePostStatus = (dispatch, id, data) =>
  dispatch({
    type: UPDATE_COMMUNITY_ITEM_STATUS_REQUEST,
    payload: apiClient.community.updatePostStatus(id, data).then(
      (res) => {
        dispatch({
          type: UPDATE_COMMUNITY_ITEM_STATUS_SUCCESS,
          id,
          res,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: UPDATE_COMMUNITY_ITEM_STATUS_FAILURE,
          err,
        }),
    ),
  });

export const updateCommentStatus = (dispatch, id, data) =>
  dispatch({
    type: UPDATE_COMMUNITY_ITEM_STATUS_REQUEST,
    payload: apiClient.community.updateCommentStatus(id, data).then(
      (res) => {
        dispatch({
          type: UPDATE_COMMUNITY_ITEM_STATUS_SUCCESS,
          id,
          res,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: UPDATE_COMMUNITY_ITEM_STATUS_FAILURE,
          err,
        }),
    ),
  });

export const removePost = (dispatch, postId) =>
  dispatch({
    type: REMOVE_POST_REQUEST,
    payload: apiClient.community.removePost(postId).then(
      (res) => {
        dispatch({
          type: REMOVE_POST_SUCCESS,
          isPostRemoval: true,
          postId,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: REMOVE_POST_FAILURE,
          err,
        }),
    ),
  });

export const removeComment = (dispatch, postId, commentId) =>
  dispatch({
    type: REMOVE_COMMENT_REQUEST,
    payload: apiClient.community.removeComment(postId, commentId).then(
      (res) => {
        dispatch({
          type: REMOVE_COMMENT_SUCCESS,
          postId,
          commentId,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: REMOVE_COMMENT_FAILURE,
          err,
        }),
    ),
  });

export const confirmDeletePost = (dispatch, postId) => {
  const modalProps = {
    bodyText: i18n.t('modal.title.areYouSure'),
    onConfirm: () => removePost(dispatch, postId),
  };
  return dispatch({
    type: SET_MODAL_TYPE,
    modalType: CONFIRM,
    modalProps,
  });
};

export const confirmDeleteComment = (dispatch, postId, commentId) => {
  const modalProps = {
    bodyText: i18n.t('modal.title.areYouSure'),
    onConfirm: () => removeComment(dispatch, postId, commentId),
  };
  return dispatch({
    type: SET_MODAL_TYPE,
    modalType: CONFIRM,
    modalProps,
  });
};

const uploadPostPhotos = (dispatch, icons, res) => {
  if (!icons?.length || icons?.[0]?.url) return null;
  const postId = res?.data?.id;
  const url = `communities/posts/${postId}/photo/`;
  return uploadImage(dispatch, icons, url);
};

export const getPostById = (dispatch, postId) =>
  dispatch({
    type: GET_POST_BY_ID_REQUEST,
    payload: apiClient.community.getPost(postId).then(
      (res) => {
        dispatch({
          type: GET_POST_BY_ID_SUCCESS,
          res,
          postId,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: GET_POST_BY_ID_FAILURE,
          err,
        }),
    ),
  });

export const createPost = (dispatch, data) => {
  const { images, ...rest } = data;
  return dispatch({
    type: SUBMIT_POST_REQUEST,
    payload: apiClient.community.createPost(rest).then(
      async (res) => {
        dispatch({
          type: SUBMIT_POST_SUCCESS,
          successMessage: i18n.t('popup.postAdded'),
          res,
        });
        images?.length && (await uploadPostPhotos(dispatch, images, res));
        return res;
      },
      (err) =>
        dispatch({
          type: SUBMIT_POST_FAILURE,
          err,
        }),
    ),
  });
};

export const updatePost = (dispatch, postId, data) => {
  const { images, ...rest } = data;
  // photo removal currently is not implemented on the api
  // if (!images?.length) {
  //   rest.photos = null;
  // }
  return dispatch({
    type: SUBMIT_POST_REQUEST,
    payload: apiClient.community.updatePost(postId, rest).then(
      async (res) => {
        dispatch({
          type: SUBMIT_POST_SUCCESS,
          successMessage: i18n.t('popup.updated'),
          res,
        });
        images?.length && (await uploadPostPhotos(dispatch, images, res));
        getPostById(dispatch, postId);
        return res;
      },
      (err) =>
        dispatch({
          type: SUBMIT_POST_FAILURE,
          err,
        }),
    ),
  });
};

export const createMessageSeller = (dispatch, data) =>
  dispatch({
    type: ADD_MESSAGE_SELLER_REQUEST,
    payload: apiClient.community.createThreads(data).then(
      async (res) => {
        dispatch({
          type: ADD_MESSAGE_SELLER_SUCCESS,
          successMessage: i18n.t('popup.messageSent'),
          res,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: ADD_MESSAGE_SELLER_FAILURE,
          err,
        }),
    ),
  });

export const clearPostsList = (dispatch) =>
  dispatch({
    type: CLEAR_POSTS_LIST_REQUEST,
  });

export const getPostsList = (dispatch, queryParams, config = {}) => {
  const { isClearPrev, isExport } = config;
  if (isClearPrev) clearPostsList(dispatch);

  const params = {
    ...queryParams,
  };

  if (params?.approval_status === 'all_pending') {
    delete params.approval_status;
    params.only_pending_content = true;
  }

  return dispatch({
    type: GET_POSTS_LIST_REQUEST,
    withoutLoading: isExport,
    payload: apiClient.community.getPostsList(params).then(
      (res) => {
        dispatch({
          type: isExport
            ? GET_ITEMS_FOR_EXPORT_SUCCESS
            : GET_POSTS_LIST_SUCCESS,
          res,
          isClearPrev,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: GET_POSTS_LIST_FAILURE,
          err,
        }),
    ),
  });
};

export const getPostCommentsList = (dispatch, postId, queryParams) =>
  dispatch({
    type: GET_POSTS_COMMENTS_LIST_REQUEST,
    payload: apiClient.community.getPostCommentsList(postId, queryParams).then(
      (res) => {
        dispatch({
          type: GET_POSTS_COMMENTS_LIST_SUCCESS,
          res,
          postId,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: GET_POSTS_COMMENTS_LIST_FAILURE,
          err,
        }),
    ),
  });

export const createPostComment = (dispatch, postId, data) =>
  dispatch({
    type: CREATE_POST_COMMENT_REQUEST,
    payload: apiClient.community.createComment(postId, data).then(
      async (res) => {
        dispatch({
          type: CREATE_POST_COMMENT_SUCCESS,
          res,
          postId,
        });
        await Promise.all([
          getPostById(dispatch, postId),
          getPostCommentsList(dispatch, postId),
        ]);
        return res;
      },
      (err) =>
        dispatch({
          type: CREATE_POST_COMMENT_FAILURE,
          err,
        }),
    ),
  });

export const togglePostLike = (dispatch, postId) =>
  dispatch({
    type: TOGGLE_POST_LIKE_REQUEST,
    payload: apiClient.community.togglePostLike(postId).then(
      (res) => {
        dispatch({
          type: TOGGLE_POST_LIKE_SUCCESS,
          res,
        });
        return getPostById(dispatch, postId);
      },
      (err) =>
        dispatch({
          type: TOGGLE_POST_LIKE_FAILURE,
          err,
        }),
    ),
  });

export const clearMembersList = (dispatch) =>
  dispatch({
    type: CLEAR_MEMBERS_LIST_REQUEST,
  });

export const getCommunityMembers = (dispatch, queryParams, isClearPrev) => {
  if (isClearPrev) {
    clearMembersList(dispatch);
  }
  return dispatch({
    type: GET_COMMUNITY_MEMBERS_LIST_REQUEST,
    payload: apiClient.community.getMembersList(queryParams).then(
      (res) => {
        dispatch({
          type: GET_COMMUNITY_MEMBERS_LIST_SUCCESS,
          res,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: GET_COMMUNITY_MEMBERS_LIST_FAILURE,
          err,
        }),
    ),
  });
};

export const getCommunityMembersForFilter = (dispatch, queryParams) =>
  dispatch({
    type: GET_COMMUNITY_MEMBERS_LIST_FOR_FILTER_REQUEST,
    payload: apiClient.community.getMembersList(queryParams).then(
      (res) => {
        dispatch({
          type: GET_COMMUNITY_MEMBERS_LIST_FOR_FILTER_SUCCESS,
          res,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: GET_COMMUNITY_MEMBERS_LIST_FOR_FILTER_FAILURE,
          err,
        }),
    ),
  });

export const getChats = (dispatch, queryParams, withReset) =>
  dispatch({
    type: GET_COMMUNITY_CHATS_REQUESTED,
    payload: apiClient.community.getThreads(queryParams).then(
      (res) => {
        dispatch({
          type: GET_COMMUNITY_CHATS_SUCCESS,
          res,
          withReset,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: GET_COMMUNITY_CHATS_FAILURE,
          err,
        }),
    ),
  });

export const threadExistsCheck = (dispatch, postId) =>
  dispatch({
    type: COMMUNITY_THREAD_EXISTS_REQUEST,
    payload: apiClient.community.threadExistsCheck(postId).then(
      (res) => {
        dispatch({
          type: COMMUNITY_THREAD_EXISTS_SUCCESS,
          res,
        });
        return res?.data;
      },
      (err) =>
        dispatch({
          type: COMMUNITY_THREAD_EXISTS_FAILURE,
          err,
        }),
    ),
  });

export const getChatInfoById = (dispatch, chatId) => {
  const queryParams = { id: chatId };
  return dispatch({
    type: GET_COMMUNITY_CHAT_INFO_BY_ID_REQUEST,
    payload: apiClient.community.getThreads(queryParams).then(
      (res) => {
        dispatch({
          type: GET_COMMUNITY_CHAT_INFO_BY_ID_SUCCESS,
          res,
          chatId,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: GET_COMMUNITY_CHAT_INFO_BY_ID_FAILURE,
          err,
        }),
    ),
  });
};

export const putNewMessage = (dispatch, threadId, data) =>
  dispatch({
    type: PUT_NEW_MESSAGE_REQUESTED,
    payload: apiClient.community.putNewMessage(threadId, data).then(
      (res) =>
        dispatch({
          type: PUT_NEW_MESSAGE_SUCCESS,
          res,
        }),
      (err) =>
        dispatch({
          type: PUT_NEW_MESSAGE_FAILURE,
          err,
        }),
    ),
  });

export const getChatById = (dispatch, chatId, queryParams, withReset) =>
  dispatch({
    type: GET_COMMUNITY_CHAT_BY_ID_REQUEST,
    payload: apiClient.community.getChatById(chatId, queryParams).then(
      (res) => {
        dispatch({
          type: GET_COMMUNITY_CHAT_BY_ID_SUCCESS,
          res,
          chatId,
          withReset,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: GET_COMMUNITY_CHAT_BY_ID_FAILURE,
          err,
        }),
    ),
  });

export const setDocumentAsAttachmentCommunity = (
  dispatch,
  documentId,
  documentName,
) =>
  dispatch({
    type: COMMUNITY_SET_DOCUMENT_ATTACHMENT,
    documentId,
    documentName,
  });

export const dropMessages = (dispatch) =>
  dispatch({ type: COMMUNITY_DROP_MESSAGES });

export const communityOptInOut = (dispatch, communityId, isOptIn) => {
  const data = { communities: [communityId] };
  const request = isOptIn
    ? apiClient.community.optIn
    : apiClient.community.optOut;

  return dispatch({
    type: COMMUNITY_OPT_IN_OUT_REQUEST,
    payload: request(data).then(
      async (res) => {
        dispatch({
          type: COMMUNITY_OPT_IN_OUT_SUCCESS,
          res,
        });
        await getUserInfo(dispatch);
        return res;
      },
      (err) =>
        dispatch({
          type: COMMUNITY_OPT_IN_OUT_FAILURE,
          err,
        }),
    ),
  });
};

export const preuploadDocumentForCommunity = (dispatch, data) =>
  dispatch({
    type: PRELOAD_DOCUMENT_REQUEST,
    payload: apiClient.community.preuploadDocument(data).then(
      (res) => {
        dispatch({
          type: PRELOAD_DOCUMENT_SUCCESS,
          successMessage: i18n.t('popup.documentPreUploaded'),
        });
        return res;
      },
      (err) =>
        dispatch({
          type: PRELOAD_DOCUMENT_FAILURE,
          err,
        }),
    ),
  });

export const banMember = (dispatch, communityId, personId, data) =>
  dispatch({
    type: BAN_MEMBER_REQUEST,
    payload: apiClient.community.banMember(communityId, personId, data).then(
      (res) => {
        dispatch({
          type: BAN_MEMBER_SUCCESS,
          successMessage: i18n.t('popup.userBaned'),
          res,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: BAN_MEMBER_FAILURE,
          err,
        }),
    ),
  });
